import React from 'react';

interface StarRatingProps {
  rating: number;
  size?: 'small' | 'medium' | 'large';
  readonly?: boolean;
  onChange?: (rating: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  size = 'medium',
  readonly = true,
  onChange
}) => {
  const [hoverRating, setHoverRating] = React.useState(0);

  const sizeMap = {
    small: { width: '16px', height: '16px' },
    medium: { width: '20px', height: '20px' },
    large: { width: '24px', height: '24px' }
  };

  const currentSize = sizeMap[size];

  const handleStarClick = (starRating: number) => {
    if (!readonly && onChange) {
      onChange(starRating);
    }
  };

  const renderStar = (starNumber: number) => {
    const filled = starNumber <= rating;
    const hovered = starNumber <= hoverRating;

    return (
      <button
        key={starNumber}
        type="button"
        onClick={() => handleStarClick(starNumber)}
        onMouseEnter={() => !readonly && setHoverRating(starNumber)}
        onMouseLeave={() => !readonly && setHoverRating(0)}
        disabled={readonly}
        style={{
          cursor: readonly ? 'default' : 'pointer',
          background: 'transparent',
          border: 'none',
          padding: 0,
          marginRight: '4px',
          transition: 'transform 0.2s',
          ...currentSize
        }}
      >
        <svg
          style={{
            ...currentSize,
            color: filled || hovered ? '#fbbf24' : '#d1d5db'
          }}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      </button>
    );
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {[1, 2, 3, 4, 5].map(renderStar)}
    </div>
  );
};

export default StarRating;